import { CardStyle } from '@hh.ru/magritte-ui';

import { AreaId } from 'src/types/area';
import { Currency, DurationDto } from 'src/types/common';
import { EducationLevel } from 'src/types/educations';
import { ProfessionId, ProfessionName } from 'src/types/profession';
import { PromotionCode } from 'src/types/promotions';
import { ProviderDto } from 'src/types/provider';
import { SkillDto } from 'src/types/skill';
import { StreamDto } from 'src/types/stream';

import { EdProgramId, EdProgramName } from 'src/types/EdProgram/common';

export enum EdProgramCoursePurpose {
    Profession = 'PROFESSION',
    Skill = 'SKILL',
}

export enum EdProgramEducationPurpose {
    HigherEducation = 'HIGHER_EDUCATION',
    SpecializedSecondaryEducation = 'SPECIALIZED_SECONDARY_EDUCATION',
}

export enum EdProgramFormat {
    ONLINE = 'ONLINE',
    OFFLINE = 'OFFLINE',
}

export type EdProgramPurpose = `${EdProgramCoursePurpose}` | `${EdProgramEducationPurpose}`;

export type EdProgramCoursePurposeFilter = EdProgramCoursePurpose | 'ALL';
export type EdProgramEducationPurposeFilter = EdProgramEducationPurpose | 'ALL';
export type EdProgramPurposeFilter = `${EdProgramCoursePurposeFilter}` | `${EdProgramEducationPurposeFilter}`;
export type EdProgramFormatFilter = EdProgramFormat | 'ALL';
export type EdProgramEducationLevelFilter = EducationLevel | 'ALL';

export enum EdProgramAgeInterval {
    Adults = 'ADULTS',
    FourteenToSeventeen = 'FOURTEEN_TO_SEVENTEEN',
    UpToThirteen = 'UP_TO_THIRTEEN',
}

export enum EdProgramStatus {
    READY = 'READY',
    PROGRESS = 'IN_PROGRESS',
    DRAFT = 'DRAFT',
}

export enum EdProgramType {
    EXTERNAL = 'EXTERNAL',
    INTERNAL = 'INTERNAL',
}

interface AdvertDto {
    ageLimit: number;
    link: string;
    advert: boolean;
}

interface HhPromotionDto {
    code: PromotionCode;
    discount: number;
}

interface ProviderPromotionDto {
    discount: number;
}

export interface PriceDetailsDto {
    amountPerMonth: number | null;
    currency: Currency;
    amount: number;
    providerPromotionAmount: number | null;
    hhPromotionAmount: number | null;
    hhPromotion: HhPromotionDto | null;
    providerPromotion: ProviderPromotionDto | null;
}

interface LevelDto {
    from: string;
    to: string | null;
}

interface ProfessionDto {
    id: ProfessionId;
    name: ProfessionName;
}

export interface EdProgramAreaDto {
    id: AreaId;
    name: string;
}

interface EdProgramBaseDto {
    id: EdProgramId;
    status: `${EdProgramStatus}`;
    name: EdProgramName;
    description: string;
    color: string;
    format: `${EdProgramFormat}` | null;
    type: `${EdProgramType}` | null;
    purpose: EdProgramPurpose;
    stream: StreamDto;
    skill: SkillDto | null;
    level: LevelDto | null;
    duration: DurationDto | null;
    priceDetails: PriceDetailsDto;
    provider: ProviderDto | null;
    advert: AdvertDto | null;
    profession: ProfessionDto | null;
    style: CardStyle | null;
    areas: EdProgramAreaDto[];
}

export interface EdProgramTypeFollowLink extends EdProgramBaseDto {
    status: EdProgramStatus.READY;
    link: string;
}

export interface EdProgramTypeSubscribe extends EdProgramBaseDto {
    status: EdProgramStatus.PROGRESS;
}

export type EdProgramDto = EdProgramTypeFollowLink | EdProgramTypeSubscribe;

export interface EdProgramListResDto {
    found: number;
    counter: {
        allCount: number;
        professionCount: number;
        skillCount: number;
    };
    items: EdProgramDto[];
    perPage: number;
    pages: number;
    page: number;
    purpose: EdProgramCoursePurposeFilter;
}

export interface EdProgramSearchSuggestDto {
    name: string;
}
